import "core-js/fn/promise";

import arrayFromPolyfill from "./array/array-from.polyfill";
import intersectionObserverPolyfill from "./intersection-observer/intersection-observer.polyfill";
import smoothscrollPolyfill from "./smoothscroll/smoothscroll.polyfill";
import elementClosestPolyfill from "./element/element-closest.polyfill";
import objectFitPolyfill from "./object-fit/object-fit.polyfill";
import customEventPolyfill from "./event/custom-event.polyfill";

const polyFills = [
    arrayFromPolyfill,
    smoothscrollPolyfill,
    intersectionObserverPolyfill,
    elementClosestPolyfill,
    objectFitPolyfill,
    customEventPolyfill,
];

export function allThePolyFills(): Promise<any> {
    const promises = polyFills.map((polyfill) => {
        return polyfill(document, window);
    });
    return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./polyfill/polyfill.ts